import _ from 'lodash';
import { loginScreen as strings } from 'ui/constants/strings';
import {
  ACCOUNT_LOGIN_SUCCESS,
  ACCOUNT_LOGIN_ERROR,
  ACCOUNT_GET_LIST_SUCCESS,
  ACCOUNT_GET_LIST_ERROR,
  TOGGLE_ACCOUNT_LOADING,
  ACCOUNT_REFRESH_ACCOUNT,
} from './actions';
import { CLEAR_DATA } from '../actions';

const initState = {
  id: null,
  username: null,
  displayName: null,
  token: null,
  isLoggedIn: false,
  error: null,
  isLoading: false,
  role: 'user',
  accountList: [],
};

const accountReducer = (state = initState, action) => {
  // console.log('accountReducer', state, action);

  const { type, payload } = action;
  switch (type) {
    case ACCOUNT_LOGIN_SUCCESS: {
      const { response } = payload;
      const { data } = response;
      return {
        ...state,
        ...data,
        isLoggedIn: true,
        error: null,
      };
    }

    case ACCOUNT_LOGIN_ERROR: {
      const { error } = payload;
      const errorMsg = _.get(error, 'response.data.msg', strings.defaultErrorMsg);
      return {
        ...state,
        isLoggedIn: false,
        error: errorMsg,
      };
    }

    case ACCOUNT_GET_LIST_SUCCESS: {
      const { response } = payload;
      const { data } = response;
      return {
        ...state,
        accountList: data,
        error: null,
      };
    }

    case ACCOUNT_GET_LIST_ERROR: {
      const { error } = payload;
      const errorMsg = _.get(error, 'response.data.msg', strings.defaultErrorMsg);
      return {
        ...state,
        isLoggedIn: false,
        error: errorMsg,
      };
    }

    case TOGGLE_ACCOUNT_LOADING: {
      const { isLoading } = payload;
      return {
        ...state,
        isLoading,
      };
    }

    case ACCOUNT_REFRESH_ACCOUNT: {
      const { response } = payload;
      const { data } = response;
      const { accountList } = state;
      const index = _.findIndex(accountList, { id: data.id });
      if (index >= 0) {
        const newArray = accountList.slice();
        newArray.splice(index, 1, data);
        return {
          ...state,
          accountList: newArray,
          error: null,
        };
      }
      return {
        ...state,
        accountList: [data, ...accountList],
        error: null,
      };
    }

    case CLEAR_DATA:
      return initState;

    default:
      return state;
  }
};

export default accountReducer;
